import React from "react";
import {ListGroupItem} from 'reactstrap';

import NotInvoicedRecord from "./not-invoiced-record";
import InvoicedRecord from "./invoiced-record";

class InvoiceTimelineItem extends React.Component {
    render() {
        const { item, toggleInvoiceModal, getInvoiceIssuers } = this.props;
         return (
            <div>
                <ListGroupItem className="">
                     { (item.Invoiced) &&
                        <InvoicedRecord getInvoiceIssuers={getInvoiceIssuers} report={item}/>
                     }
                    {
                        (!item.Invoiced) &&
                        <NotInvoicedRecord getInvoiceIssuers={getInvoiceIssuers} toggleInvoiceModal = {toggleInvoiceModal} report={item}/>
                    }
                </ListGroupItem>
            </div>
        )
    }
}
export default InvoiceTimelineItem;


// WEBPACK FOOTER //
// ./src/views/invoice/timeline-item.js